module.exports = __webpack_public_path__ + "static/media/arrow-left.6b86f09c.svg";